module.exports = __webpack_public_path__ + "static/media/spin.80ac0911.mp3";